import React, {useEffect} from 'react';
import {View} from 'react-native';
import {useQuery} from '@tanstack/react-query';
import {useDispatch, useSelector} from 'react-redux';
import {setHunts, setHuntsList} from '../Redux/reducers/hunts.reducer';
import {setThemes} from '../Redux/reducers/themes.reducer';
import {saveBackupRegion} from '../Redux/reducers/user_location.reducer';
import {apiGetAllHunts, apiGetHuntThemes} from '../Utils/apiCalls';
import {orderHuntsByProximity} from '../Utils/distanceHelpers';

const HuntsController = () => {
  // getting data

  const dispatch = useDispatch();
  const homeSearchText = useSelector((state) => state.home.homeSearchText);
  const roundedRegion = useSelector(
    (state) => state.location.roundedRegion || {},
  );
  const {latitude: roundedLat, longitude: roundedLong} = roundedRegion;

  console.log('HuntsController', {
    roundedLat,
    homeSearchText,
    roundedLong,
  });
  const hunts = useSelector((state) => state.hunts.hunts);

  // fetching hunt list
  useQuery([`scavengerHunts`], async () => {
    const huntData = await apiGetAllHunts();
    if (!huntData) {
      console.error('apiGetAllHunts failed');
      throw new Error('no local locations');
    } else {
      console.log('apiGetAllHunts succeeded');
      console.log('updating hunts');
      dispatch(setHunts(huntData));
    }
    return huntData;
  });

  useEffect(() => {
    var sortedHunts = orderHuntsByProximity(hunts, {
      latitude: roundedLat,
      longitude: roundedLong,
    });

    if (homeSearchText) {
      sortedHunts = sortedHunts.filter((hunt) => {
        // console.log('hunt: ', hunt)
        const casedText =
          typeof homeSearchText == 'string'
            ? homeSearchText?.toLowerCase?.()
            : homeSearchText;

        if (!casedText) {
          return hunt;
        }
        const city =
          typeof hunt.city == 'string' ? hunt.city?.toLowerCase?.() : hunt.city;
        const name =
          typeof hunt.name == 'string' ? hunt.name?.toLowerCase?.() : hunt.name;
        const state =
          typeof hunt.state == 'string'
            ? hunt.state?.toLowerCase?.()
            : hunt.state;

        // filtering hunts by type
        // if there is a search
        if (
          (casedText?.includes('indoor') || casedText?.includes('in home')) &&
          hunt.hunt_type == 'inHome'
        ) {
          if (
            !hunt?.name?.includes('Office') &&
            !hunt?.name?.includes('Team')
          ) {
            return hunt;
          }
        }
        if (casedText?.includes('outdoor') && hunt.hunt_type == 'scavaHunt') {
          return hunt;
        }

        if (casedText?.includes('bar h') && hunt.hunt_type == 'barHunt') {
          return hunt;
        }

        if (casedText?.includes('art') && hunt.hunt_type == 'artWalk') {
          return hunt;
        }

        if (casedText?.includes('ghost') && hunt.hunt_type == 'ghostHunt') {
          return hunt;
        }

        if (casedText?.includes('zoo') && hunt.hunt_type == 'zooHunt') {
          return hunt;
        }

        if (name?.includes?.(casedText)) {
          return hunt;
        }

        if (state?.includes?.(casedText)) {
          return hunt;
        }

        if (city?.includes?.(casedText)) {
          return hunt;
        }
      });
    }
    dispatch(setHuntsList(sortedHunts));
  }, [JSON.stringify(hunts || {}), roundedLat, roundedLong, homeSearchText]);

  // getting hunt themes
  useEffect(() => {
    apiGetHuntThemes().then((themeData) => {
      console.log('==========================');
      console.log('theme data loaded');
      console.log('==========================');
      if (themeData) {
        console.log('setting the theme data', {themeData});
        dispatch(setThemes(themeData));
      }
      if (themeData?.geo_location) {
        dispatch(saveBackupRegion(themeData?.geo_location));
      }
    });
  }, []);

  // const hunts

  return <View style={{}}></View>;
};

export default HuntsController;
